import React from 'react'
import SectionTitle from './SectionTitle'

const OurStory = () =>
  <section className="our-story">
    <div className='container'>
      <SectionTitle title='Our Story' color='blue' />
      <p>Last year, U.S. companies struggled to fill more than 1.3 million job openings for software development. The market is reponding to this demand, but most students turn to standalone code development boot camps for the answer.</p>
    </div>
  </section>

export default OurStory
